import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["draggable"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-block-editor-prefix', { 'gfu-block-editor-prefix--draggable': $props.allowDrag }, { '_jcc': $options.shouldCenterIcon }]),
    draggable: $options.draggableAttr,
    onDragstart: _cache[0] || (_cache[0] = (...args) => ($options.onDragStart && $options.onDragStart(...args))),
    onDragend: _cache[1] || (_cache[1] = (...args) => ($options.onDragEnd && $options.onDragEnd(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      ($props.allowDrag)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: "grip-lines",
            draggable: "false"
          }))
        : _createCommentVNode("v-if", true)
    ])
  ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}